import React, { useState } from 'react';

export default function Body() {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isPhoneInputFocused, setIsPhoneInputFocused] = useState(false);

    return (
        <main className="flex flex-col items-center justify-center px-6 pt-32 max-w-md mx-auto lg:max-w-2xl">
           

            {/* Main Headline */}
            <h1 className="text-white text-2xl md:text-[28px] font-bold text-center mb-4 leading-tight">
                Snap a photo, get protein!
            </h1>

            {/* Description */}
            <p className="text-app-gray text-sm md:text-base text-center leading-relaxed mb-12 md:mb-16 px-2 text-paragraph">
                Our app can calculate calories, protein, fiber, fat,
                and carbohydrates.
            </p>
        </main>
    );
}
